import _ from 'underscore';
import GenericModel from 'js/models/generic.model';
require('metroHelpers');

var TheModel = GenericModel.extend({
    urlRoot: '/CampaignCloud/UserInfo',
    url: function () {
        return this.urlRoot;
    },
    idAttribute: 'id',
    defaults: {
        id: 0,
        username: "Current User",
        firsName: null,
        firstName: null,
        email: null,
        msisdn: null,
        locale: null,
        role: null,
        createDate: null,
        roles: null,
        emailAvailable: null,
        emailReserved: null,
        creditsAvailable: null,
        creditsReserved: null,
        creditsSpent: null,
        creditBound: null,
        numOfCampaigns: null
    },
    myName: function () {
        if (!this.get("firstName") && !this.get("lastName")) {
            return this.get("username");
        }
        return (this.get("firstName") ? this.get("firstName") : "") +
            (this.get("firstName") && this.get("lastName") ? " " : "") +
            (this.get("lastName") ? this.get("lastName") : "");
    }
}, {
    singleton: null,
    getSingleton: function () {
        if (!TheModel.singleton) {
            TheModel.singleton = new TheModel;

            TheModel.singleton.fetch({
                success: function (model, data) {
                    if (data && data.outcome && data.outcome !== "OK") {
                        $.Notify.error('Error retrieving user: ' + (data.reason ? data.reason : ''));
                    }
                },
                error: function (data) {
                    $.Notify.error("Error retrieving user, status = " + (data.status ? data.status : ""));
                }
            });
        }
        return TheModel.singleton;
    }
});
export default TheModel;
